import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import plugin from '@/utils/install.js'
// 路由拦截器
import '@/utils/permission'
// 采用配置导入
// import '@/styles/index.scss' // global css
import '@/components/install.js' // global components
Vue.use(ElementUI)
Vue.use(plugin); // global function

Vue.config.productionTip = false

// CSS in JS 响应式判断
// if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
//     Vue.prototype.equipmentSide = 'MobilePhone'
// } else {
//     Vue.prototype.equipmentSide = 'PCTerminal'
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')